import { ToggleGroup } from 'radix-ui'
import { cn } from '../cn.ts'

export interface SegmentedOption<T extends string> {
  value: T
  label: string
}

export interface SegmentedProps<T extends string> {
  value: T
  options: ReadonlyArray<SegmentedOption<T>>
  onValueChange: (value: T) => void
  'aria-label': string
  className?: string
}

export function Segmented<T extends string>({
  value,
  options,
  onValueChange,
  className,
  ...rest
}: SegmentedProps<T>) {
  return (
    <ToggleGroup.Root
      type="single"
      value={value}
      onValueChange={(v) => v && onValueChange(v as T)}
      className={cn('inline-flex rounded-pill border border-line-2 bg-grey-1 p-0.5', className)}
      aria-label={rest['aria-label']}
    >
      {options.map((o) => (
        <ToggleGroup.Item
          key={o.value}
          value={o.value}
          className={cn(
            'h-8 rounded-pill px-3.5 font-medium text-[13px] text-text-2 transition-colors duration-150 ease-out',
            'data-[state=on]:bg-card data-[state=on]:text-text-1 data-[state=on]:shadow-1',
          )}
        >
          {o.label}
        </ToggleGroup.Item>
      ))}
    </ToggleGroup.Root>
  )
}
